import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ScopoSocialeWarningsService } from './warnings/scopo-sociale.warnings';
import { ScopoSocialeFieldValidators } from './validators/scopo-sociale.field-validators';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [ScopoSocialeWarningsService, ScopoSocialeFieldValidators],
})
export class ScopoSocialeFormModule {}
